import {SourceLayerParam} from '../dynamicParameters.enums';
import {DPLayerMapping} from '../dynamicParameters.types';
import getMappingParam from './getMappingParam';

function getPropsKeyFromMapping(mappingObj: DPLayerMapping, param: SourceLayerParam) {
  const value = getMappingParam(mappingObj, param);

  return {
    paramName: value?.paramKey,
    itemIdx: value?.index,
    isDynamic: !!(value?.index + 1),
  };
}

export default getPropsKeyFromMapping;
